import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { createPortal } from 'react-dom';
import { setEducationalMessage } from '../appSlice';
import { selectSecondaryFilter } from '../features/secondaryFilter/secondaryFilterSlice';
// import { getImage } from '../utilities/iconResolver';
import { t } from '../utilities/translator';
import queryString from 'query-string';
import { pushEvent } from '../utilities/analytics';
import { EDUCATIONAL_MESSAGES } from '../constants/analyticEvents';
import { selectFilterData, selectFiltersLoaded } from '../features/mainFilter/selectors';
import { setFilterInteractionCount } from '../app/slices/countersSlice';

export default function EducationalMessages() {
  const dispatch = useDispatch();
  const filtersReady = useSelector(selectFiltersLoaded);
  const mainFilter = useSelector(selectFilterData);
  const secondaryFilter = useSelector(selectSecondaryFilter);
  const educationalMessage = useSelector((state) => state.app.educationalMessage);
  const { filtersInteractionCount } = useSelector(state => state.counters)
  const [uhp, setUhp] = useState();
  const objectOfMessage = window?.holidayFinder?.educational_msgs;
  const objectOfMessageByType = objectOfMessage
    ? objectOfMessage[uhp]
    : objectOfMessage;
  const listOfMessage = objectOfMessageByType?.list;
  const portal = document.getElementById('modal-portal');

  useEffect(() => {
    const parsed = queryString.parse(window.location.search);
    const uhpFromUrl = parsed?.uhp;
    const uhpFromLs = localStorage.getItem('uhp');
    if (uhpFromUrl) {
      localStorage.setItem('uhp', uhpFromUrl);
      return setUhp(uhpFromUrl);
    } else if (uhpFromLs) {
      return setUhp(uhpFromLs);
    } else {
      setUhp('generic');
    }
  }, []);

  useEffect(() => {
    if (!listOfMessage) return undefined;
    if (
      (filtersInteractionCount === 4 ||
        (filtersInteractionCount - 4) % 8 === 0) &&
      filtersInteractionCount !== 0
    ) {
      const messageIndex =
        ((filtersInteractionCount - 4) / 8) % listOfMessage.length;
      const message = listOfMessage[messageIndex];
      dispatch(setEducationalMessage(message));

      pushEvent(EDUCATIONAL_MESSAGES, {
        page: 'list',
        uhp: `##${uhp}##`,
        message: `##${message}##`,
      });
    }
  }, [filtersInteractionCount]);

  useEffect(() => {
    let timeout = null;
    if (educationalMessage) {
      timeout = setTimeout(() => {
        dispatch(setEducationalMessage(''))
      }, 6000);
    }

    return () => clearTimeout(timeout);
  }, [dispatch, educationalMessage]);

  useEffect(() => {
    if (!filtersReady) return;
    const lsCount = +localStorage.getItem('filtersInteractionCount');
    const counter =
      lsCount > filtersInteractionCount ? lsCount : filtersInteractionCount;
    dispatch(setFilterInteractionCount(counter + 1));
    localStorage.setItem('filtersInteractionCount', counter + 1);
  }, [dispatch, filtersReady, mainFilter.searchEngine, secondaryFilter.data]);

  if (!portal) {
    return null;
  }

  return createPortal(
    <div className={cn("edu-message__wrap", { 'edu-message__hide': !educationalMessage })}>
      <div className="edu-message">
        <div className="edu-message__loader" />
        <div className="edu-message__text">{educationalMessage}</div>
        {/* <object
          className="edu-message__image"
          type="image/svg+xml"
          data={getImage('educational-messages-loader.svg')}
        >
          Educational message
        </object> */}
        <div className="edu-message__bottom">
          {t('app.pleaseWaitWhileWeSelectTheBestPackageDealsForYou')}{' '}
        </div>
      </div>
    </div>,
    portal
  );
}
